/* unplugin-vue-components disabled */import { render } from "./signal-sources.vue?vue&type=template&id=5a11f910&scoped=true"
import script from "./signal-sources.vue?vue&type=script&lang=js"
export * from "./signal-sources.vue?vue&type=script&lang=js"

import "./signal-sources.vue?vue&type=style&index=0&id=5a11f910&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a11f910"],['__file',"src/pages/pulse/signal/signal-sources.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a11f910"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a11f910', __exports__)) {
    api.reload('5a11f910', __exports__)
  }
  
  module.hot.accept("./signal-sources.vue?vue&type=template&id=5a11f910&scoped=true", () => {
    api.rerender('5a11f910', render)
  })

}


export default __exports__